<template>

  <div
    class='page-live-followPop'
    :style="{height: `${popHeight}rem`,overflow: `${popHeight === 0 ? 'hidden': 'inherit'}`}"
  >
    <div>
      <div class="user-img">
        <img
          :src="$store.state.userInfo.avatarUrl"
          alt=""
        >
        <div class="clamp1">{{$store.state.userInfo.nickName}}</div>
      </div>
      <ul class="info">
        <li>
          <p class="num">{{$store.state.userInfo.fansCount}}</p>
          <p class="name">粉丝</p>
        </li>
        <li>
          <p class="num">{{$store.state.userInfo.followCount}}</p>
          <p class="name">关注</p>
        </li>
      </ul>
      <div class="clamp1 intro">{{$store.state.userInfo.instruction}}</div>
    </div>
    <ul class="btn-group">
      <li
        class="add-follow"
        @click="$openApp"
        v-if="!isFollow"
      >+ 关注</li>
      <li
        v-else
        @click="$openApp"
      >已关注</li>
      <li @click="goUserCenter">主页</li>
    </ul>
  </div>

</template>

<script>
export default {
  name: 'live-followPop',
  props: {
    popHeight: {
      type: Number,
      default: 0,
    },
    isFollow: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    goUserCenter() {
      this.$router.push({
        path: 'userCenter',
        query: {
          userId: this.$route.query.userId,
        },
      });
    },
  },
};
</script>

<style lang='less' scoped>
.page-live-followPop {
  height: 0;
  overflow: hidden;
  background: #ffffff;
  border-radius: 6px 6px 0px 0px;
  font-size: 16px;
  color: #333333;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-shadow: none;
  transition: height 0.5s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1000004;
  ul {
    display: flex;
    justify-content: center;
    p{
      text-align: center;
    }

  }
  .info {
    .num{
      font-size: 18px;
    }
    .name{
      font-size: 14px;
      color: #999999;
      margin-top: 5px;
    }
    >li:first-child{
      margin-right: 50px;
    }
    >li:last-child{
      margin-left: 50px;
    }
  }
  .intro{
    font-size: 16px;
    font-weight: 400;
    padding: 20px;
    text-align: center;
  }
  .btn-group {
    height: 55px;
    line-height: 55px;
    border-top: 1px solid #979797;
    .add-follow {
      color: rgba(225,38,77,1);
      position: relative;
    }
    >li:first-child::after{
      content: "";
      display: block;
      position: absolute;
      right: 0;
      height: 20px;
      width: 1px;
      background: #cccccc;
      top: 18px;
    }
    li{
      text-align: center;
      flex: 1;
    }
  }
  .user-img{
    font-weight: 600;
    text-align: center;
    margin-top: -30px;
    img{
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }
    >div{
     padding: 10px;
    }
  }
}
</style>
